import React from "react";

function AnimatedButton({
  children,
  style = {},
  className = "",
  ...props
}) {
  return (
    <button
      className={`hookora-button-motion ${className}`}
      style={{
        transition:
          "transform 180ms cubic-bezier(0.22,1,0.36,1), box-shadow 220ms ease",
        ...style
      }}
      {...props}
    >
      {children}
    </button>
  );
}

export default AnimatedButton;